import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'status'
})
export class StatusPipe implements PipeTransform {
  transform(status: string): string {
    switch (status) {
      case 'CREATED': {
        return '<span class="label label-info"> <span class="fa fa-cart-plus"></span> Creé </span>';
      }
      case 'DA_STARTING': {
        return '<span class="label label-info-dark"> <span class="fa fa-hourglass-start"></span> DA Crée </span>';
      }
      case 'DA_DELIVRED': {
        return '<span class="label label-default"> <span class="fa fa-hourglass-start"></span> DA delivrée </span>';
      }
      case 'INLABO': {
        return '<span class="label label-warning"> <span class="fa fa-flask"></span> Analyse en cours </span>';
      }
      case 'ANALYSE_DONE': {
        return '<span class="label label-success"> <span class="fa fa-flask"></span> Analyse terminée </span>';
      }
      case 'OPEN': {
        return '<span class="label label-success"> <span class="fa fa-check"></span> En cours </span>';
      }
      case 'PAIED': {
        return '<span class="label label-danger"> <span class="fa fa-credit-card"></span> Payée </span>';
      }
      case 'CLOSED': {
        return '<span class="label label-danger"> <span class="fa fa-close"></span> Fermée </span>';
      }
      case 'VALIDATED': {
        return '<span class="label label-success"> <span class="fa fa-check"></span> Validée </span>';
      }
      case 'PRE_VALIDATED': {
        return '<span class="label label-warning"> <span class="fa fa-cart-plus"></span> Préliminaire </span>';
      }
      default: {
        return '<span class="label label-default">' + status + '</span>';
      }
    }

  }
}
